module.exports = __webpack_public_path__ + "static/media/signup-bg.0ebc594d.png";